const stats = [
  { num: "35+", label: "Secret data sources scanned in real-time", sub: "Reddit, TikTok, Etsy, Patents, Discord & more" },
  { num: "6 mo", label: "Average head-start on emerging trends", sub: "Before they hit mainstream radar" },
  { num: "94%", label: "Of users launched their first product in <30 days", sub: "Using a generated blueprint" },
];

const Stats = () => (
  <section className="py-24 border-y border-border bg-secondary/20">
    <div className="container grid md:grid-cols-3 gap-12">
      {stats.map((s, i) => (
        <div key={i} className="text-center md:text-left">
          <div className="font-display text-7xl md:text-8xl font-bold text-gradient-primary leading-none">
            {s.num}
          </div>
          <div className="mt-4 text-lg font-semibold">{s.label}</div>
          <div className="mt-1 text-sm text-muted-foreground">{s.sub}</div>
        </div>
      ))}
    </div>
  </section>
);

export default Stats;
